import { useActiveUserSessionsQuery } from '../../../../slices/account-api.slice';
import { DeleteButton, TertiaryButton } from '@workday/canvas-kit-react/button';
import { autoId, useReactModal } from '@workday/upc-common';
import { ID_ACTIVE_SESSIONS_ERROR, ID_CANCEL_BUTTON, ID_SESSION_LOGOUT_BUTTON } from '../../../../autoIds';
import React from 'react';
import '../../SettingsModalContent.scss';
import styles from './SessionDetailsEntry.module.scss';
import { LoadingDots } from '@workday/canvas-kit-react';
import { SessionInfoEntry } from './SessionInfoEntry';
import Modal from 'react-modal';
import { ConfirmLogoutSessions } from './ConfirmLogoutSessions';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { OverflowTooltip } from '@workday/canvas-kit-react/tooltip';

export function SessionDetailsEntry({ onCloseModal }) {
    const {
        data,
        isLoading,
        isError,
        error: sessionErrorMessage
    } = useActiveUserSessionsQuery(undefined, {
        refetchOnMountOrArgChange: true
    });

    const { t } = useTranslation('account');

    const sessionEndConfirmationModal = useReactModal({ modalProps: { shouldCloseOnEsc: false } });

    return (
        <div className={classNames('settingsModalContent', styles.sessionDetailsEntry)}>
            <h1>{t('SessionDetailsEntry.title')}</h1>
            <div>
                {isLoading ? (
                    <LoadingDots role='progressbar' />
                ) : isError ? (
                    <div {...autoId(ID_ACTIVE_SESSIONS_ERROR)}>{String(sessionErrorMessage)}</div>
                ) : (
                    <SessionInfoEntry sessionDetails={data.sessionDetails} />
                )}
            </div>
            <div className={styles.footer}>
                <div>
                    <OverflowTooltip>
                        <DeleteButton
                            onClick={sessionEndConfirmationModal.open}
                            {...autoId(ID_SESSION_LOGOUT_BUTTON)}
                            type={'button'}
                            size={'large'}
                            grow={false}
                            className={styles.button}>
                            {t('SessionDetailsEntry.openModal')}
                        </DeleteButton>
                    </OverflowTooltip>
                </div>
                <div className={styles.cancel}>
                    <TertiaryButton
                        {...autoId(ID_CANCEL_BUTTON)}
                        type='button'
                        size='large'
                        onClick={onCloseModal}
                        className={styles.button}>
                        {t('Common.cancel', { ns: 'shared' })}
                    </TertiaryButton>
                </div>
                <Modal {...sessionEndConfirmationModal.modalProps}>
                    <div>
                        <ConfirmLogoutSessions onCloseModal={sessionEndConfirmationModal.close} />
                    </div>
                </Modal>
            </div>
        </div>
    );
}
